import { Box } from "@mui/material";
import { ReactNode } from "react";

import StyledLargeButton from "components/Styled/Button/StyledLargeButton";

import styles from "../styles";

interface Props {
  onBack: () => void;
  onNext?: () => void;
  backLabel?: string;
  nextLabel?: string;
  nextIcon?: string;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  secondaryAction?: ReactNode;
}

export default function StepNav({
  onBack,
  onNext,
  backLabel = "Back",
  nextLabel = "Next",
  nextIcon = "fa-regular fa-arrow-right",
  nextDisabled,
  nextLoading,
  secondaryAction,
}: Props) {
  return (
    <Box sx={styles.footer}>
      <StyledLargeButton
        color="secondary"
        onClick={onBack}
        styles={{ px: { xs: 3, md: 5 } }}
      >
        <Box
          component="i"
          className="fa-regular fa-arrow-left"
          sx={{ mr: 1 }}
        />
        {backLabel}
      </StyledLargeButton>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
        {secondaryAction}
      </Box>
      {onNext && (
        <StyledLargeButton
          color="primary"
          onClick={onNext}
          disabled={nextDisabled}
          loading={nextLoading}
          styles={{ px: { xs: 3, md: 5 } }}
        >
          {nextLabel}
          <Box component="i" className={nextIcon} sx={{ ml: 1 }} />
        </StyledLargeButton>
      )}
    </Box>
  );
}
